/**
 * Credits render as dollars. Widens past 2dp for sub-cent amounts so a real
 * charge never reads "$0.00". Mirrors formatAmount() on the server (notification copy).
 */
export function formatCredits(credits: number): string {
  const n = Number.isFinite(credits) ? credits : 0;
  const abs = Math.abs(n);
  const maximumFractionDigits = abs > 0 && abs < 0.01 ? Math.min(9, Math.floor(-Math.log10(abs)) + 2) : 2;
  // Rounds half up on the decimal digits first: iOS rounds a value like 2270.305 down, Android and web round it up.
  const value = maximumFractionDigits === 2 ? Math.sign(n) * Number(`${Math.round(Number(`${abs}e2`))}e-2`) : n;
  return `$${value.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits })}`;
}
